// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Emmy","title":"Header_title__SLomL","left":"Header_left__3sUZp","clinicName":"Header_clinicName__OwVXH"};